const currentYear = new Date().getFullYear();
export const DEFAULT_WW_SEASON_CODE = `${currentYear.toString().slice(-2)}h`;

export interface WelcomeWeekSeason {
  id: string;
  organization_id: string;
  code: string;
  name: string;
  year: number;
  season: 'h' | 'v';
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface WelcomeWeekMasterEvent {
  id: string;
  organization_id: string;
  season_id: string;
  title: string;
  description: string | null;
  starts_at: string;
  ends_at: string;
  location_name: string | null;
  location_address: string | null;
  location_url: string | null;
  category: string;
  sort_order: number;
  revision?: number;
  source_event_key?: string | null;
  created_by?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface WelcomeWeekGroupAdmin {
  group_id: string;
  user_id: string;
  profiles?: {
    id: string;
    display_name: string | null;
    email?: string | null;
    avatar_url?: string | null;
  } | null;
}

export interface WelcomeWeekGroupInvitation {
  invitation_id: string;
  group_id: string;
  email: string;
  created_at?: string | null;
  expires_at?: string | null;
  accepted_at?: string | null;
  consumed_at?: string | null;
}

export interface WelcomeWeekGroup {
  id: string;
  organization_id: string;
  season_id: string;
  code: string;
  name: string;
  slug: string;
  feed_token: string;
  admin_invite_token?: string;
  created_by?: string | null;
  created_at?: string;
  updated_at?: string;
  admins?: WelcomeWeekGroupAdmin[];
  pendingInvitations?: WelcomeWeekGroupInvitation[];
}

export interface WelcomeWeekOverride {
  id: string;
  organization_id: string;
  season_id: string;
  group_id: string;
  master_event_id: string;
  override_title: string | null;
  override_description: string | null;
  override_location_name: string | null;
  override_location_address: string | null;
  override_location_url: string | null;
  override_starts_at: string | null;
  override_ends_at: string | null;
  notes: string | null;
  is_hidden: boolean;
  revision?: number;
  updated_by?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface WelcomeWeekEffectiveEvent {
  id: string;
  source_event_key: string | null;
  sort_order: number;
  title: string;
  description: string | null;
  notes?: string | null;
  starts_at: string;
  ends_at: string;
  location_name: string | null;
  location_address: string | null;
  location_url: string | null;
  category: string;
  sequence?: number;
  last_modified?: string;
}

export interface WelcomeWeekPublicOverview {
  organization?: {
    id: string;
    name: string;
    slug: string;
    description?: string | null;
    avatar_url?: string | null;
  };
  season?: WelcomeWeekSeason & {
    master_feed_path?: string;
  };
  groups?: Array<WelcomeWeekGroup & { feed_path?: string }>;
  master_events?: WelcomeWeekEffectiveEvent[];
  sources?: WelcomeWeekCalendarSource[];
}

/** A display-safe calendar source returned by the public programme RPC. */
export interface WelcomeWeekCalendarSource {
  source_key: 'fadder' | 'central';
  label: string;
}

/** Source metadata returned only to an organization owner or admin. */
export interface WelcomeWeekAdminCalendarSource extends WelcomeWeekCalendarSource {
  calendar_username: string;
  calendar_stem: string;
}

export interface WelcomeWeekGroupFeed {
  organization?: {
    id: string;
    name: string;
    slug: string;
  };
  season?: WelcomeWeekSeason;
  group?: WelcomeWeekGroup & { feed_path?: string };
  events?: WelcomeWeekEffectiveEvent[];
}
